// Default types for Initial Context

/**
 * Relationship types for covered persons relative to the account holder
 */
export const RELATIONSHIP_TO_ACCOUNT_HOLDER = {
  SELF: "self",
  FAMILY_MEMBER: "familyMember",
  CHILD: "child",
  SPOUSE: "spouse",
} as const;

export type RelationshipToAccountHolder =
  (typeof RELATIONSHIP_TO_ACCOUNT_HOLDER)[keyof typeof RELATIONSHIP_TO_ACCOUNT_HOLDER];

export interface DefaultApp {
  platformVersion: string;
  sdkVersion: string;
  platform: string;
}

export interface DefaultCustomData {
  deviceModel?: string;
  operatingSystem?: string;
  country?: string;
  appVersion?: string;
  deviceId?: string;
}

export interface DefaultPatient {
  gender: "unknown" | "male" | "female";
  firstName: string;
  relationshipToAccountHolder: string;
  id: string;
  birthDate: number | string;
  lastName: string;
  custom?: DefaultCustomData;
}

export interface DefaultAccount {
  paymentId: string;
  id: string;
  selectedPatient: DefaultPatient;
  email: string;
  custom: DefaultCustomData;
  coveredPersons: Array<DefaultPatient>;
}

export interface DefaultComponent {
  [key: string]: any;
}

export type DefaultInitialContext = {
  startingRoute: string;
  component: DefaultComponent;
  account: DefaultAccount;
  app: DefaultApp;
  accessToken: string;
};
